import { useEffect } from "react";
import { createPortal } from "react-dom";
import CloseModal from "../../components/Atomos/Icons/EditMode/CloseModal";
import Button from "../../components/staff/Button";
import { Cancel } from "../../components/Atomos/Icons/Cancel";

type HelpCenterDeleteGroupConfirmModalProps = {
  isOpen: boolean;
  isSubmitting?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

export default function HelpCenterDeleteGroupConfirmModal({
  isOpen,
  isSubmitting = false,
  onCancel,
  onConfirm,
}: HelpCenterDeleteGroupConfirmModalProps) {
  useEffect(() => {
    if (!isOpen) {
      return;
    }

    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = originalOverflow;
    };
  }, [isOpen]);

  if (!isOpen) {
    return null;
  }

  return createPortal(
    <div
      className="help-center-delete-group-overlay"
      onClick={isSubmitting ? undefined : onCancel}
    >
      <div
        className="help-center-delete-group-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="help-center-delete-group-title"
        onClick={(event) => event.stopPropagation()}
      >
        <button
          type="button"
          className="help-center-delete-group-close"
          aria-label="Close"
          disabled={isSubmitting}
          onClick={onCancel}
        >
          <CloseModal />
        </button>

        <p
          id="help-center-delete-group-title"
          className="help-center-delete-group-modal-message"
        >
          Do you want to erase this group?
        </p>

        <div className="help-center-delete-group-modal-actions">
          <Button
            text="Cancel"
            color="white"
            variant="outlined"
            size="fixed"
            icon={<Cancel />}
            iconPosition="right"
            className="help-center-edit-cancel-button help-center-delete-group-modal-button"
            disabled={isSubmitting}
            onClick={onCancel}
          />
          <Button
            text="Confirm"
            color="secondary"
            variant="filled"
            size="fixed"
            className="help-center-edit-save-button help-center-delete-group-modal-button"
            disabled={isSubmitting}
            onClick={onConfirm}
          />
        </div>
      </div>
    </div>,
    document.body,
  );
}
